import React, { useState } from "react";
import { Link, Navigate } from "react-router-dom";
import { connect } from "react-redux";
import { registerUser } from "../../actions/authActions";
import { setAlert } from "../../actions/alertActions";

import { Container, Grid } from "semantic-ui-react";
import styles from "./Register.module.scss";
import {
  Heading1,
  Body1,
} from "../../components/value-cssmodules/TextComponent";
import { isAuthenticatedSelector } from "../../utils/selectors";
import UserForm from "./UserForm";
import { useSelector } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";

type StateProps = {
  isAuthenticated: boolean;
};
type DispatchProps = {
  setAlert: (msg: any, type: any) => void;
  registerUser: ({ name, email, user }: any) => void;
};

const Register: React.FunctionComponent<DispatchProps & StateProps> = ({
  setAlert,
  registerUser,
  isAuthenticated,
}) => {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    password: "",
    password2: "",
  });
  const { name, email, password, password2 } = formData;
  const id = useSelector((state: any) => state.auth?.user?._id)

  const onChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const intl = useIntl();

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    if (password !== password2) {
      setAlert(
        intl.formatMessage({
          id: "register.errors.passwordMismatch",
          defaultMessage: "Passwords do not match",
        }),
        "danger"
      );
    } else {
      registerUser({ name, email, password });
    }
  };

  if (isAuthenticated) {
    return <Navigate to= {`/profile/${id}`} replace />;
  }

  return (
    <div className={styles.self}>
      <Container>
        <Grid centered>
          <Grid.Column mobile={16} computer={12}>
            <Heading1 className={styles.centered}>
              <FormattedMessage
                id="register.page.title"
                defaultMessage="Register"
              />
            </Heading1>
            <Body1 className={styles.registerP}>
              <FormattedMessage
                id="register.page.subtitle"
                defaultMessage="Join the Sew Light community"
              />
            </Body1>
            <UserForm
              data={formData}
              onChange={onChange}
              onSubmit={onSubmit}
              edit={false}
              onCheckboxChange={() => null}
            />
            <Body1 className={styles.registerConditionsP}>
              <FormattedMessage
                id="register.conditions.part1"
                defaultMessage="By registering, you confirm that you have read "
              />
              <Link to="/platform-terms">
                <FormattedMessage
                  id="register.conditions.termsLink"
                  defaultMessage="the terms and conditions"
                />
              </Link>
              <FormattedMessage
                id="register.conditions.part2"
                defaultMessage=" and accept the "
              />
              <Link to="/platform-terms?page=designers">
                <FormattedMessage
                  id="register.conditions.serviceTermsLink"
                  defaultMessage="service terms"
                />
              </Link>
              <FormattedMessage
                id="register.conditions.part3"
                defaultMessage=" and the "
              />
              <Link to="/platform-terms?page=privacy-policy">
                <FormattedMessage
                  id="register.conditions.privacyPolicyLink"
                  defaultMessage="privacy policy"
                />
              </Link>
              <FormattedMessage id="register.conditions.part4" defaultMessage="." />
            </Body1>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};

const mapStateToProps = (state: any) => ({
  isAuthenticated: isAuthenticatedSelector(state),
});

const mapDispatchToProps = (dispatch: any) => ({
  registerUser: (object: any) => dispatch(registerUser(object)),
  setAlert: (msg: any, type: any) => dispatch(setAlert(msg, type)),
});

export default connect(mapStateToProps, mapDispatchToProps)(Register);
